<div class="timeline-container">
    <div *ngFor="let milestone of milestones; let i = index" class="timeline-item">
        <div class="timeline-icon-container m-auto" [ngClass]="{
            'timeline-icon-container-green': milestone.state === 'Aprobado',
            'timeline-icon-container-red': milestone.state === 'Rechazado'
        }">
            <fa-icon *ngIf="milestone.state === 'Aprobado'" icon="check"
                class="timeline-icon timeline-icon-green"></fa-icon>
            <fa-icon *ngIf="milestone.state === 'Rechazado'" icon="times"
                class="timeline-icon timeline-icon-red"></fa-icon>
            <fa-icon *ngIf="milestone.state === 'Pendiente'" icon="hourglass-half" class="timeline-icon"></fa-icon>

        </div>
        <div class="timeline-content">
            <h5 class="timeline-content-title"><span *ngIf="milestone.state === 'Pendiente'">Pendiente </span>{{
                milestone.key }}</h5>
            <span class="timeline-content-date">{{ milestone.date }}</span>
        </div>
        <!-- Mostrar este párrafo para todos excepto el último elemento -->
        <div *ngIf="i < milestones.length - 1" [ngClass]="getTimelineClass(milestone.state)">
        </div>


    </div>
</div>